<app-user-dashboard [userMenuActiveItemIndex]="0" [activeItem]="'user-load-pallets-orders'">
  <p-breadcrumb class="max-w-full" [model]="breadcrumbItems" [home]="breadcrumbHomeItem"></p-breadcrumb>
  <div style="margin-top:1em">
    <div class="card">
      <div class="header-card">

          <div class="container-title">
            <!--
              <button (click)="goToLoadsPage()" class="btn-circle bg-yellow" style="margin-right:1em" >
                <i class="pi pi-arrow-left"></i>
              </button>
            -->
            <h2 class="title-main">{{'UserPages.UserLoadContainersOrders.PageTitle' | translate}}</h2>
          </div>
          <div class="col-12 md:col-6 p-fluid flex align-items-center">
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input type="text" pInputText placeholder="{{'UserPages.UserLoadOrders.SearchProducts' | translate}}" class="p-inputtext-sm"  [(ngModel)]="searchTerm" (input)="filterLoads()" />
            </span>
          </div>
          <div></div>
      </div>
      <div class="body-card">
        <div class="subtitle-container">
          <h4 class="subtitle">
            {{'UserPages.UserLoadContainersOrders.Exporter' | translate}}
          </h4>
          <button type="button" pButton pRipple
            icon="pi pi-file-excel"
            class="p-button-success mr-2 button-success-style"
            pTooltip="XLS"
            (click)="exportExcel(loadContainersTable)"
            tooltipPosition="bottom"
            [loading]="loading"
            [style]="{'width':'fit-content', 'margin-left': '2px'}">
            {{ 'UserPages.UserLoadOrders.ExportExcel' | translate }}
          </button>
        </div>
        <div class="container-filters filters-size">
          <section class="section-info" *ngIf="profile">
            <section class="column-info">
              <section class="section-data">
                <i class="pi pi-user" style="margin-right:.5em; color:grey"></i>
                {{companyName}}
              </section>
              <section class="section-data">
                <i class="pi pi-at" style="margin-right:.5em; color:grey"></i>
                {{profile.contactEmail}}
              </section>
            </section>
            <section class="column-info">
              <section class="section-data">
                <i class="pi pi-map-marker" style="margin-right:.5em; color:grey"></i>
                {{profile.contactAddress}}
              </section>
              <section class="section-data">
                <i class="pi pi-phone" style="margin-right:.5em; color:grey"></i>
                {{profile.contactPhone}}
              </section>
            </section>
          </section>

          <div class="section-filters">
            <div class="grid-filters">
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="container-filter"
                    [options]="containerFilter"
                    (onChange)="loadContainersTable.filter($event.value, 'containerNumber', 'in')"
                    [filter]="true"
                    [showClear]="false"
                    [(ngModel)]="selectedContainers"
                    class="multiselect"
                  />
                  <label for="container-filter">
                    {{'UserPages.UserLoadContainersOrders.filters.containerFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="week-filter"
                    [options]="weekFilter"
                    (onChange)="loadContainersTable.filter($event.value, 'week', 'in')"
                    [filter]="true"
                    [showClear]="false"
                    class="multiselect"
                  />
                  <label for="week-filter">
                    {{'UserPages.UserLoadContainersOrders.filters.weekFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="importer-filter"
                    [options]="importerFilter"
                    (onChange)="loadContainersTable.filter($event.value, 'importer', 'in')"
                    [filter]="true"
                    [(ngModel)]="selectedCompanies"
                    [showClear]="false"
                    class="multiselect"
                  />
                  <label for="importer-filter">
                    {{'UserPages.UserLoadContainersOrders.filters.importerFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="specie-filter"
                    [options]="specieFilter"
                    (onChange)="loadContainersTable.filter($event.value, 'species', 'in')"
                    [filter]="true"
                    [showClear]="false"
                    class="multiselect"
                  />
                  <label for="specie-filter">
                    {{'UserPages.UserLoadContainersOrders.filters.specieFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="variety-filter"
                    [options]="varietyFilter"
                    (onChange)="loadContainersTable.filter($event.value, 'variety', 'in')"
                    [filter]="true"
                    [showClear]="false"
                    class="multiselect"
                  />
                  <label for="variety-filter">
                    {{'UserPages.UserLoadContainersOrders.filters.varietyFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                    id="ship-filter"
                    [options]="shipFilter"
                    (onChange)="loadContainersTable.filter($event.value, 'ship', 'in')"
                    [filter]="true"
                    [showClear]="false"
                    class="multiselect"
                  />
                  <label for="ship-filter">
                    {{'UserPages.UserLoadContainersOrders.filters.naveFilter' | translate}}
                  </label>
                </span>
              </div>
              <div class="dropdown-container">
                <span class="p-float-label">
                  <p-multiSelect
                  id="year-filter"
                  [options]="years"
                  [(ngModel)]="yearSelect"
                  class="multiselect"
                  [selectionLimit]="1"
                  (onChange)="searchLoadContainers($event)"
                  placeholder="{{'MyLoadFilter.SelectYear' | translate}}"
                  >
                  </p-multiSelect>
                  <label for="year-filter">
                    {{'MyLoadFilter.YearLabel' | translate}}
                  </label>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="container-table">
          <div  class="section-table">
            <p-table
              #loadContainersTable
              [value]="filteredRegisters"
              dataKey="product.pallet.id"
              [loading]="loading"
              [paginator]="true"
              [rows]="100"
              [rowsPerPageOptions]="[100, 200, 500, 1000]"
              [scrollable]="true"
              (onFilter)="filterTable($event)"
              [resizableColumns]="true"
              columnResizeMode="expand"
              scrollHeight="800px"
              [tableStyle]="{ 'min-width': '50rem' }"
              [globalFilterFields]="['containerNumber', 'week', 'importer', 'species', 'variety', 'ship']"
              [showCurrentPageReport]="true"
              currentPageReportTemplate="Mostrando desde {first} hasta {last} de {totalRecords} resultados"
              styleClass="p-datatable-gridlines">
              <ng-template pTemplate="header">
                <tr>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.ImportOrderIdHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.ImporterHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.WeeksHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.ETAHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.ETDHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.ContainerHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.EspecieHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.VarietyHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.PackagingHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.NetKilosHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.LabelHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.SpeciesSize' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.BoxesPerPalletHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.VesselNameHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.OriginPortHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.DestinationPortHeader' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.PricePerBox' | translate}}</th>
                  <th>{{'UserPages.UserLoadContainersOrders.MainTable.Incoterms' | translate}}</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-product>
                <tr>
                  <td>{{ product.importOrderId }}</td>
                  <td>{{ product.importer }}</td>
                  <td>{{ product.week }}</td>
                  <td>{{ product.etd | date: 'dd-MM-yyyy'}}</td>
                  <td>{{ product.eta | date: 'dd-MM-yyyy'}}</td>
                  <td>{{ product.containerNumber }}</td>
                  <td>{{ product.species }}</td>
                  <td>{{ product.variety }}</td>
                  <td>{{ product.packaging }}</td>
                  <td>{{ product.netKilos }}</td>
                  <td>{{ product.boxType }}</td>
                  <td>{{ product.speciesSize }}</td>
                  <td>{{ product.boxesPerPallet }}</td>
                  <td>{{ product.ship }}</td>
                  <td>{{ product.departurePort }}</td>
                  <td>{{ product.destinationPort }}</td>
                  <td>$ {{ product.importOrderDetail?.price }}</td>
                  <td>{{ product.incoterms }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-user-dashboard>
